import React, { FC } from 'react';
import './Confirmation.css';
import { Trans, useTranslation } from 'react-i18next';

export const Confirmation: FC<{}> = () => {
    const { t } = useTranslation();
    
  return (
    <div className="confirmation">
      <div className="message-container">
        <h1 className="message">
          <Trans>
            {t(
              "messagesUtilisateurs.sendConfirmation"
            )}
          </Trans>
        </h1>
      </div>
    </div>
  );
};
